import { render, staticRenderFns } from "./TemplateNav.vue?vue&type=template&id=00043c28&scoped=true"
import script from "./TemplateNav.vue?vue&type=script&lang=js"
export * from "./TemplateNav.vue?vue&type=script&lang=js"
import style0 from "./TemplateNav.vue?vue&type=style&index=0&id=00043c28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00043c28",
  null
  
)

export default component.exports